import { chain, map } from 'fp-ts/lib/TaskEither';
import { flow, pipe } from 'fp-ts/lib/function';
import {
  addVersionForUpdate,
  createAuthorizedDeleteRequest,
  createAuthorizedGetRequest,
  createAuthorizedPostRequest,
  createAuthorizedPutRequest, decode,
  decodeId,
  decodeVersioned,
  fetchApi,
  setBody,
  Versioned,
} from '../../..';
import { detailCodec, formSendCodec } from '@/services/api/resources/issue/v2';
import { resourceBulkDelete } from '@/services/api/resources/bulkDelete';
import { IssueSendable } from '@/entities/issue/v2';
import { dataCommentCodec } from '@/services/api/resources/activity';

const baseIssueUrl = '/v2/issues';
const recordUrl = (id: number): string => `${baseIssueUrl}/${id}`;

export const get = flow(
  recordUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decodeVersioned(detailCodec)),
);

export const update = (id: number, issue: Versioned<IssueSendable>) => pipe(
  id,
  recordUrl,
  createAuthorizedPutRequest,
  map(addVersionForUpdate(issue.version)),
  map(setBody(formSendCodec.encode(issue.data))),
  chain(fetchApi),
);

export const create = (issue: IssueSendable) => pipe(
  baseIssueUrl,
  createAuthorizedPostRequest,
  map(setBody(formSendCodec.encode(issue))),
  chain(fetchApi),
  chain(decodeId),
);

export const remove = flow(
  recordUrl,
  createAuthorizedDeleteRequest,
  chain(fetchApi),
);

export const createComment = (id: string, comment: string) => pipe(
  `${baseIssueUrl}/${id}/comments`,
  createAuthorizedPostRequest,
  map(setBody({ comment })),
  chain(fetchApi),
  chain(decode(dataCommentCodec)),
);

export const bulkDelete = (records: number[]) => resourceBulkDelete(records, '/v2/issues');
